(() => {
  if (window.ksCollectionWishlistV2Initialized) return;
  window.ksCollectionWishlistV2Initialized = true;

  const STORAGE_KEY = 'm-wishlist-products';
  const BUTTON_SELECTOR =
    '.facest-filters-section .ks-card-wishlist .m-wishlist-button[data-product-handle]';
  const ADDED_CLASS = 'added-to-wishlist';
  const ADD_LABEL = 'Adaugă la favorite';
  const REMOVE_LABEL = 'Elimină din favorite';

  const asElement = (target) => {
    if (target instanceof Element) return target;
    return target && target.parentElement ? target.parentElement : null;
  };

  const readWishlist = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      if (!Array.isArray(stored)) return [];
      return [...new Set(stored.map(String).filter(Boolean))];
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      return true;
    } catch (error) {
      return false;
    }
  };

  const updateButton = (button, added) => {
    const label = added ? REMOVE_LABEL : ADD_LABEL;
    button.classList.toggle(ADDED_CLASS, added);
    button.setAttribute('aria-pressed', added ? 'true' : 'false');
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);

    button
      .querySelectorAll('.m-wishlist-button-text, .m-tooltip__content')
      .forEach((element) => {
        element.textContent = label;
      });
  };

  const syncThemeWishlist = (items) => {
    const wishlist =
      window.MinimogTheme && window.MinimogTheme.Wishlist
        ? window.MinimogTheme.Wishlist
        : null;

    if (!wishlist) return;
    wishlist.products = items.slice();
    if (typeof wishlist.updateWishlistCount === 'function') {
      wishlist.updateWishlistCount();
    }
  };

  const syncWishlistUi = (providedItems) => {
    const items = providedItems || readWishlist();
    const selected = new Set(items);

    document.querySelectorAll(BUTTON_SELECTOR).forEach((button) => {
      updateButton(button, selected.has(button.dataset.productHandle));
    });

    const count = items.length;
    document.querySelectorAll('.m-wishlist-count').forEach((element) => {
      element.textContent = String(count);
      element.classList.toggle('m:hidden', count === 0);
      if (count > 0 && element.style.display === 'none') {
        element.style.removeProperty('display');
      }
    });

    if (document.body) {
      document.body.classList.toggle('wishlist-has-item', count > 0);
    }

    syncThemeWishlist(items);
  };

  const toggleWishlist = (event, button) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }
    }

    if (!button) return false;
    const productHandle = (button.dataset.productHandle || '').trim();
    if (!productHandle) return false;

    const items = readWishlist();
    const currentIndex = items.indexOf(productHandle);
    const added = currentIndex === -1;

    if (added) {
      items.push(productHandle);
    } else {
      items.splice(currentIndex, 1);
    }

    const uniqueItems = [...new Set(items)];
    writeWishlist(uniqueItems);
    syncWishlistUi(uniqueItems);

    window.dispatchEvent(
      new CustomEvent('ks:wishlist:updated', {
        detail: {
          productHandle,
          added,
          count: uniqueItems.length,
        },
      })
    );

    return false;
  };

  window.ksToggleCollectionWishlist = toggleWishlist;

  document.addEventListener(
    'click',
    (event) => {
      const target = asElement(event.target);
      const button = target && target.closest(BUTTON_SELECTOR);
      if (!button) return;
      toggleWishlist(event, button);
    },
    true
  );

  document.addEventListener('click', (event) => {
    const target = asElement(event.target);
    if (!target) return;

    const card = target.closest(
      '.facest-filters-section .ks-collection-product-card'
    );
    if (!card) return;

    if (
      target.closest(
        'a, button, input, select, textarea, label, form, [role="button"], .ks-card-interactive'
      )
    ) {
      return;
    }

    const cardLink = card.querySelector('.ks-card-main-link[href]');
    if (cardLink && cardLink.href) {
      window.location.assign(cardLink.href);
    }
  });

  const start = () => {
    syncWishlistUi();

    let syncScheduled = false;
    const observer = new MutationObserver(() => {
      if (syncScheduled) return;
      syncScheduled = true;
      window.requestAnimationFrame(() => {
        syncScheduled = false;
        syncWishlistUi();
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) syncWishlistUi();
  });
})();
